let locales = {
    parameterList_title: "Global parameters",
    parameterList_key: "KEY",
    parameterList_description: "Description",
    parameterList_value: "Value",
    parameterList_type: "Type",
};

export default locales;